import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SongCard from "@/components/SongCard";
import { Search } from "lucide-react";

export default function Store() {
  const [songs, setSongs] = useState([]);
  const [tab, setTab] = useState("all");
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/songs", { params: { limit: 100 } }).then((r) => setSongs(r.data));
  }, []);

  const list = songs.filter((s) => {
    if (tab === "mp4" && !s.video_url) return false;
    if (q && !`${s.title} ${s.artist} ${s.album || ""}`.toLowerCase().includes(q.toLowerCase())) return false;
    return true;
  });

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="mb-12 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <p className="eyebrow mb-3">The store</p>
          <h1 className="font-display text-5xl md:text-6xl tracking-tight font-light">Own what you love.</h1>
          <p className="text-neutral-500 max-w-md mt-3">Secure checkout via Stripe. MP3 $1.99, MP4 $2.99. Instant delivery on payment.</p>
        </div>
        <div className="flex gap-2">
          <button data-testid="store-tab-all" onClick={() => setTab("all")} className={`btn-pill text-xs ${tab==="all"?"btn-primary":"btn-outline"}`}>All</button>
          <button data-testid="store-tab-mp3" onClick={() => setTab("mp3")} className={`btn-pill text-xs ${tab==="mp3"?"btn-primary":"btn-outline"}`}>MP3</button>
          <button data-testid="store-tab-mp4" onClick={() => setTab("mp4")} className={`btn-pill text-xs ${tab==="mp4"?"btn-primary":"btn-outline"}`}>MP4</button>
        </div>
      </div>

      <div className="relative mb-10 max-w-md">
        <Search size={16} strokeWidth={1.5} className="absolute left-4 top-1/2 -translate-y-1/2 text-neutral-400" />
        <input
          data-testid="store-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search the store"
          className="w-full h-11 pl-11 pr-4 rounded-full bg-white border border-[--sanctum-border] focus:outline-none text-sm"
        />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 xl:gap-8">
        {list.map((s, i) => <SongCard key={s.id} song={s} index={i} />)}
      </div>
    </div>
  );
}
